import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from 'react-flexbox-grid';
import config from '../../config';
import TableRankingIndividualItem from '../TableRankingIndividualItem';
import TableRankingTeamItem from '../TableRankingTeamItem';

import EmptyState from '../EmptyState';
import { handleResponse, serializeQuery } from '../../utils/handleResponse';

const getLocalUser = () => {
  try {
    return JSON.parse(localStorage.getItem('userData') || 'null');
  } catch (e) {
    return null;
  }
};

const buildAuthRequestOptions = (method = 'GET', body) => {
  const athlete = getLocalUser();
  const headers = athlete?.userToken
    ? { Authorization: `Bearer ${athlete.userToken}` }
    : undefined;

  return {
    method,
    ...(headers ? { headers } : {}),
    ...(body ? { body, headers: { ...headers, 'Content-Type': 'application/json' } } : {}),
  };
};

const TableRankingIndividual = ({
  setShowLoading,
  setShowSecondLoading,
  individualFavorites,
  saveFavorite,
  deleteFavorite,
  changeIndividual,
  filterText,
  selectedGenderFilter,
  selectedTeamGenderFilter,
  distanceFilter,
  distanceTeamFilter,
  selectedTab,
  teamFavorites,
  saveTeamFavorite,
  deleteTeamFavorite,
  favoritesEnabled,
}) => {
  const [rakings, setRakings] = useState([]);
  const [teamRakings, setTeamRakings] = useState([]);
  const [rakingsFavorite, setRakingsFavorite] = useState([]);
  const [teamRakingsFavorite, setTeamRakingsFavorite] = useState([]);

  const getRanking = async () => {
    setShowLoading(true);
    const requestOptions = buildAuthRequestOptions('GET');

    const params = {
      page: 1,
      limit: 2000,
      orderByTotalDistance: true,
    };

    if (selectedGenderFilter) {
      params['gender'] = selectedGenderFilter;
    }
    if (distanceFilter || distanceFilter === 0) {
      params['distance'] = distanceFilter;
    }

    if (filterText) {
      params['search'] = filterText;
    }

    const url = new URL(
      `${config.tncApiUrl}/sport-events/individual-participants/${config.eventId}`
    );
    url.search = serializeQuery(params);

    const response = await fetch(url, requestOptions);

    setShowLoading(false);
    try {
      const newRankings = await handleResponse(response);
      setRakings(newRankings.data.participants);
    } catch (error) {
      console.log('error', error);
    }
  };

  const fetchParticipantLaps = async (participantId) => {
    try {
      setShowLoading(true);
      const requestOptions = buildAuthRequestOptions('GET');

      const response = await fetch(
        `${config.tncApiUrl}/participant/${participantId}/laps`,
        requestOptions
      );

      // Deja de mostrar loading
      setShowLoading(false);

      // Maneja la respuesta
      const lapsData = await handleResponse(response);
      // lapsData.data => sueles tener la info en data, ajusta según tu backend
      return lapsData.data;
    } catch (error) {
      console.error('Error fetching laps:', error);
      setShowLoading(false);
      throw error;
    }
  };

  const getTeamRanking = async () => {
    setShowLoading(true);
    const requestOptions = buildAuthRequestOptions('GET');

    const params = {
      page: 1,
      limit: 2000,
      orderByTotalDistance: true,
    };

    console.log('selectedTeamGenderFilter', selectedTeamGenderFilter);
    if (selectedTeamGenderFilter) {
      params['gender'] = selectedTeamGenderFilter;
    }
    if (distanceTeamFilter || distanceTeamFilter === 0) {
      params['distance'] = distanceTeamFilter;
    }

    if (filterText) {
      params['search'] = filterText;
    }

    const url = new URL(
      `${config.tncApiUrl}/sport-events/teams/${config.eventId}`
    );
    url.search = serializeQuery(params);

    const response = await fetch(url, requestOptions);

    setShowLoading(false);
    try {
      const newRankings = await handleResponse(response);
      setTeamRakings(newRankings.data.teams);
    } catch (error) {
      console.log('error', error);
    }
  };

  const getTeamRankingFavorite = async () => {
    const athlete = getLocalUser();
    if (!athlete?.userToken || !athlete?.user?.id) {
      setTeamRakingsFavorite([]);
      return;
    }
    setShowLoading(true);
    const requestOptions = buildAuthRequestOptions('GET');

    const params = {
      page: 1,
      limit: 2000,
      userId: athlete.user.id,
      orderByTotalDistance: true,
    };

    if (selectedTeamGenderFilter) {
      params['gender'] = selectedTeamGenderFilter;
    }
    if (distanceTeamFilter || distanceTeamFilter === 0) {
      params['distance'] = distanceTeamFilter;
    }

    if (filterText) {
      params['search'] = filterText;
    }

    const url = new URL(
      `${config.tncApiUrl}/sport-events/teams/${config.eventId}/favorite`
    );
    url.search = serializeQuery(params);

    const response = await fetch(url, requestOptions);

    setShowLoading(false);
    try {
      const newRankings = await handleResponse(response);
      if (
        newRankings.data.message ===
        'No favorites found for the given user and event.'
      ) {
        setRakingsFavorite([]);
      } else {
        setTeamRakingsFavorite(newRankings.data.teams);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const getRankingFavorite = async () => {
    const athlete = getLocalUser();
    if (!athlete?.userToken || !athlete?.user?.id) {
      setRakingsFavorite([]);
      return;
    }
    setShowLoading(true);
    const requestOptions = buildAuthRequestOptions('GET');

    const params = {
      page: 1,
      limit: 2000,
      userId: athlete.user.id,
      orderByTotalDistance: true,
    };

    if (selectedGenderFilter) {
      params['gender'] = selectedGenderFilter;
    }
    if (distanceFilter || distanceFilter === 0) {
      params['distance'] = distanceFilter;
    }

    if (filterText) {
      params['search'] = filterText;
    }

    const url = new URL(
      `${config.tncApiUrl}/sport-events/individual-participants/${config.eventId}/favorite`
    );
    url.search = serializeQuery(params);

    const response = await fetch(url, requestOptions);

    setShowLoading(false);
    try {
      const newRankings = await handleResponse(response);
      if (
        newRankings.data.message ===
        'No favorites found for the given user and event.'
      ) {
        setRakingsFavorite([]);
      } else {
        setRakingsFavorite(newRankings.data.participants);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    if (favoritesEnabled && individualFavorites?.length) {
      getRankingFavorite();
    } else {
      setRakingsFavorite([]);
    }
  }, [individualFavorites, favoritesEnabled]);

  useEffect(() => {
    if (favoritesEnabled && teamFavorites?.length) {
      getTeamRankingFavorite();
    } else {
      setTeamRakingsFavorite([]);
    }
  }, [teamFavorites, favoritesEnabled]);

  useEffect(() => {
    if (selectedTab === 0) {
      getRanking();
    } else if (selectedTab === 1) {
      getTeamRanking();
    }
  }, [
    selectedTab,
    distanceFilter,
    distanceTeamFilter,
    selectedGenderFilter,
    selectedTeamGenderFilter,
    changeIndividual,
  ]);

  useEffect(() => {
    if (!favoritesEnabled) return;
    if (selectedTab === 0) {
      getRankingFavorite();
    } else if (selectedTab === 1) {
      getTeamRankingFavorite();
    }
  }, [
    favoritesEnabled,
    selectedTab,
    distanceFilter,
    distanceTeamFilter,
    individualFavorites,
    teamFavorites,
    changeIndividual,
  ]);

  return (
    <Col xs={12}>
      <Row>
        {selectedTab === 0 &&
          rakings.length > 0 &&
          rakingsFavorite.map((raking) => {
            return (
              <TableRankingIndividualItem
                userInfo={raking}
                key={`favorite${raking._id}`}
                darkMode
                firstRaking={rakings[0]}
                individualFavorites={individualFavorites}
                saveFavorite={saveFavorite}
                deleteFavorite={deleteFavorite}
                setShowLoading={setShowLoading}
                favoritesEnabled={favoritesEnabled}
              />
            );
          })}
        {rakings.length === 0 && <EmptyState />}
        {selectedTab === 0 &&
          rakings.map((raking) => {
            return (
              <TableRankingIndividualItem
                userInfo={raking}
                key={`individual${raking.id}`}
                individualFavorites={individualFavorites}
                saveFavorite={saveFavorite}
                deleteFavorite={deleteFavorite}
                firstRaking={rakings[0]}
                setShowLoading={setShowLoading}
                favoritesEnabled={favoritesEnabled}
              />
            );
          })}
        {selectedTab === 1 &&
          teamRakings.length > 0 &&
          teamRakingsFavorite.map((raking) => {
            return (
              <TableRankingTeamItem
                darkMode
                userInfo={raking}
                key={`favorite${raking.id}`}
                firstRaking={teamRakings[0]}
                teamFavorites={teamFavorites}
                saveTeamFavorite={saveTeamFavorite}
                deleteTeamFavorite={deleteTeamFavorite}
                setShowLoading={setShowLoading}
                favoritesEnabled={favoritesEnabled}
              />
            );
          })}
        {selectedTab === 1 &&
          teamRakings.map((raking) => {
            return (
              <TableRankingTeamItem
                userInfo={raking}
                key={`team${raking.id}`}
                firstRaking={teamRakings[0]}
                teamFavorites={teamFavorites}
                saveTeamFavorite={saveTeamFavorite}
                deleteTeamFavorite={deleteTeamFavorite}
                setShowLoading={setShowLoading}
                favoritesEnabled={favoritesEnabled}
              />
            );
          })}
      </Row>
    </Col>
  );
};

TableRankingIndividual.propTypes = {
  setShowLoading: PropTypes.func.isRequired,
  setShowSecondLoading: PropTypes.func.isRequired,
  individualFavorites: PropTypes.array.isRequired,
  saveFavorite: PropTypes.func.isRequired,
  deleteFavorite: PropTypes.func.isRequired,
  selectedGenderFilter: PropTypes.string,
  selectedTeamGenderFilter: PropTypes.string,
  distanceFilter: PropTypes.string,
  distanceTeamFilter: PropTypes.string,
  filterText: PropTypes.string,
  changeIndividual: PropTypes.number,
  selectedTab: PropTypes.number,
  teamFavorites: PropTypes.array.isRequired,
  saveTeamFavorite: PropTypes.func.isRequired,
  deleteTeamFavorite: PropTypes.func.isRequired,
  favoritesEnabled: PropTypes.bool,
};

TableRankingIndividual.defaultProps = {
  selectedGenderFilter: null,
  selectedTeamGenderFilter: null,
  distanceFilter: null,
  distanceTeamFilter: null,
  changeIndividual: null,
  filterText: null,
  selectedTab: null,
  favoritesEnabled: false,
};

export default TableRankingIndividual;
